const log = window.log;

function postToCart(items, successCallback, loadingCallback, failCallback) {
  if (loadingCallback) loadingCallback();
  $.post("/cart/add.js", { items }, successCallback)
    .fail(() => { failCallback && failCallback(); alert("Error adding items to the cart.") });
}


function buildCart(options = {}) {
  const delay = options.skipDelay ? 0 : 1000;
  setTimeout(() => {
    const cart_item = [];
    jQuery.getJSON("/cart.js", cart => {
      log.collapse(cart, "Cart Data", "success");

      const ENABLE_UPGRADE_TO_SUBSCRIPTION = true;
      const SHOW_DISCOUNT_PERCENTAGE = true;
      const SHOW_COMPARE_AT_PRICE = true;

      const currency = $('.cd__checkout-btn').attr('data-cur').replace('0,00', '').replace('0.00', '');
      const excludedProductIds = [8068685103204, 7904233160804];
      let compare_price_integer = 0;
      // Filter out the excluded product when counting items
      let filteredItemCount = 0;

      cart.items.forEach(item => {
        if (excludedProductIds.includes(item.product_id)) return; // Skip the excluded product
        filteredItemCount += item.quantity; // Add quantity for items that are not excluded

        const pd = window.product_json[item.product_id];
        let price = (item.line_price / 100).toFixed(2);
        let compare_price = (item.original_line_price / 100).toFixed(2);
        if (item.selling_plan_allocation) {
          log.table({
            "Compare at Price": compare_price,
            "Selling Plan Allocation Compare": item.selling_plan_allocation.compare_at_price,
          }, "Selling Plan Allocation", "info");
          if (item.selling_plan_allocation.compare_at_price * item.quantity > parseFloat(compare_price) * 100) {
            compare_price = (item.selling_plan_allocation.compare_at_price * item.quantity / 100).toFixed(2)
          }
        }

        if (SHOW_COMPARE_AT_PRICE) {
          try {
            if (!pd) throw `No productData for ${item.product_id}`;
            if (item.product_has_only_default_variant) {
              if (typeof pd.compare_at_price !== 'number') throw `No compare_at_price for ${item.product_id}`;
              compare_price = (pd.compare_at_price * item.quantity / 100).toFixed(2);
            } else {
              const v = pd.variants?.find(v => v.id === item.id);
              if (!v || typeof v.compare_at_price !== 'number') throw `No variantData/compare_at_price for ${item.id}`;
              compare_price = (v.compare_at_price * item.quantity / 100).toFixed(2);
            }
            log.collapse(pd, 'productData');
          } catch (e) {
            log.collapse(e, 'compare_price error', 'error');
          }
        }

        compare_price_integer += parseFloat(compare_price);

        let price_line = (parseFloat(compare_price) > parseFloat(price) ? `${currency}${price} <s>${currency}${compare_price}</s> ` : `${currency}${price} `);
        log.table(item, "Item", "success");
        log.table({
          "Element": "Cart",
          "Final Price": item.final_price,
          "Original Price": item.original_price,
          "Compare Price": compare_price,
          "Compare Price Parsed": parseFloat(compare_price),
          "Price": price,
          "Price Parsed": parseFloat(price),
          "Saved Price": parseFloat(compare_price) - parseFloat(price),
          "Saved Percentage": (parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price),
          "Saved Percentage Rounded": Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price))
        }, "Price Details", "info");

        // if (SHOW_DISCOUNT_PERCENTAGE) price_line += (item.original_price > item.final_price ? `<span class="discount">${Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price))}% OFF</span>` : '');
        if (SHOW_DISCOUNT_PERCENTAGE) {
          const discount_percentage = Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price));
          price_line += (discount_percentage > 0 ? `<span class="discount">${discount_percentage}% OFF</span>` : '');
        }

        const variant_option1 = item.variant_options[0], variant_option2 = item.variant_options[1];
        const cart_option1_line = variant_option1 && variant_option1 !== 'Default Title' ? `<p class="cd__item-variant">${variant_option1}</p>` : '';
        const cart_option2_line = variant_option2 && variant_option2 !== 'Default Title' ? `<p class="cd__item-variant"><span>${variant_option2}</span></p>` : '';
        const item_title = item.product_title;

        // Check if the item can be converted to a subscription
        let upgradePrompt = '';
        if (
          ENABLE_UPGRADE_TO_SUBSCRIPTION &&
          !item.selling_plan_allocation &&
          window.product_json &&
          window.product_json[item.product_id] &&
          window.product_json[item.product_id].selling_plan_groups
        ) {
          const plans = window.product_json[item.product_id].selling_plan_groups;
          log(plans, 'plans');
          const plan = plans.find(g => g.selling_plans && g.selling_plans.some(p => p.name && p.name.includes("4 Week")));

          if (plan) {
            const planObj = plan.selling_plans.find(p => p.name && p.name.includes("4"));
            if (planObj && planObj.id) {
              const planId = planObj.id;
              log(`Adding Upgrade To Sub for: ${item.id}, SubPlanId: ${planId}`);

              const checkIconUrl = "https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Cart_Check_Icon_01f26807-a2bd-4637-a7c1-1500415b9130.png?v=1738853428";
              const points = ["Lock-In Current Price", "Pause Or Cancel Anytime", "Free Express Shipping"]
                .map(p => `<point><img src="${checkIconUrl}" width="20" height="20"><p>${p}</p></point>`).join("");

              upgradePrompt = `
                <flex-col class="KD_cart_item_upgrade_wrapper">
                  <p class="KD_cart_item_upgrade_label">76% of our users choose subscription</p>
                  <flex-row class="KD_cart_item_upgrade">
                    <button type="button" class="KD_cart_upgrade_btn" data-id="${item.id}" data-plan-id="${planId}"></button>
                    <p>Upgrade to Subscription & <strong>Save 10%</strong> per purchase!</p>
                  </flex-row>
                  <flex-row class="KD_cart_item_upgrade_points">${points}</flex-row>
                </flex-col>
              `;
            }
          }
        }

        const giftThreshold = $('.discount-bar__threshold[data-type="gift"]').data('id');
        const giftItem = item.product_id === giftThreshold;

        // Add bundle properties if they exist
        const bundleProperties = item.properties ? Object.entries(item.properties).map(([key, value]) => `${key}: ${value}`).join(' ') : '';

        const productVariants = pd && pd.variants && pd.variants.length > 1 ? `
          <flex class="cd__item-selector main-select themed" data-type="size" aria-label="size-options">
            <div class="main-select__label active">
              <p>${(pd.variants.find(v => v.id === item.id) || pd.variants[0]).title}</p>
              <flex-center class="main-select__icon">
                <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#000" d="M6 8.825L1.175 4 2.05 3.125 6 7.075 9.95 3.125 10.825 4z"/>
                </svg>
              </flex-center>
            </div>
            <flex-col class="main-select__menu">
              ${pd.variants.map(v => `
                <div class="main-select__item size" aria-label="size-option" data-value="${v.id}"${v.id === item.id ? ' data-selected="true"' : ''}>
                  <span class="item-label">${v.title}</span>
                </div>
              `).join('')}
            </flex-col>
          </flex>
        ` : '';

        log.collapse({ Properties: item.properties }, 'item.properties', 'warning');
        cart_item.push(`
          <div class="cd__item" data-id="${item.id}" data-key="${item.key}">
            <div><img loading="lazy" src="${item.image}&width=100" alt="${item_title}"></div>
            <div>
              <p class="cd__item-title">${item_title}</p>
              <div class="cd__item-variants">${cart_option1_line}${cart_option2_line}</div>
              <p class="cd__item-price">${price_line}</p>
              ${!giftItem ? `<flex class="cd__item-selector-wrapper">
                <div class="cd__item-quantity">
                  <div class="cd__item-quantity-minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></div>
                  <div class="cd__item-quantity-value">${item.quantity}</div>
                  <div class="cd__item-quantity-plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg></div>
                </div>
                ${productVariants}
              </flex>` : ''}
            </div>
            <div>
              <div class="cd__item-remove">
                <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0625/9304/0484/files/streamline_delete-1.png?v=1748117648" alt="x-icon"><span class="loader"></span>
              </div>
            </div>
            ${item.properties ? `<div class="cd__item-properties" data-properties="${encodeURIComponent(JSON.stringify(item.properties))}" style="display:none;">
              ${Object.entries(item.properties).map(([k, v]) => `<div>${k}: ${typeof v === 'object' && v ? `<pre>${JSON.stringify(v, null, 2)}</pre>` : v}</div>`).join('')}</div>`
            : ''}
          </div>
          ${upgradePrompt}
        `);
      });

      // Check if only the excluded product remains
      if (filteredItemCount === 0 && cart.items.length > 0) $.post("/cart/clear.js", function () { log('Cart cleared'); return buildCart(); }, "json");


      const cart_total = (cart.total_price / 100).toFixed(2);
      const youSave = (compare_price_integer - (cart.total_price / 100)).toFixed(2);

      if (cart.item_count === 0) {
        $('.nr_cart_empty').show();
        $('.cd__units span').html('0');
        $('cart-drawer-content, .cd__progress, .cd__footer, .cart-count-bubble, .cd__timer-reserved').hide();
      } else {
        $('.cd__timer-reserved, .cart-count-bubble, cart-drawer-content, .cd__footer, .cd__progress').show();
        $('.nr_cart_empty').hide();
        $(".cart-count-bubble span").text(filteredItemCount); // Use the filtered count here
        $('.cd_content__js').html(cart_item);
        $('.cd__units span').html(filteredItemCount);

        if (filteredItemCount == 1) {
          $('.cd__units span').html(filteredItemCount);
        }

        const save_line = $('.cd__footer-prices-line[data-value="save"]');
        if (cart_total >= compare_price_integer) {
          setTimeout(() => {
            save_line.hide();
          }, 50);
        } else {
          setTimeout(() => {
            save_line.css('display', 'flex');
            save_line.find('span.value').html(currency + youSave);
          }, 50);
        }

        // Shipping logic
        // const shipping_line = $('.cd__footer-prices-line[data-value="shipping"]');
        // const shipping_cost = (cart_total > 3000) ? '0.00 €' : '0 €';
        // shipping_line.find('span.value').html(`${shipping_cost}<s>0 €</s>`);
        // const total_with_shipping = cart_total > 3000 ? cart_total : cart_total + 0;
        // $('.cd__footer-prices-line[data-value="total"] span.value').html(`${currency}${cart_total} <s>${currency}${total_with_shipping}</s>`);

        $('.cd__footer-prices-line[data-value="total"] span.value').html(`${currency}${cart_total}`);
        $('.cd__checkout-price').html(currency + cart_total);
      }

      $('.cd-upsells__carousel').slick('refresh');
      if ($('discount-progress-bar').length) updateDiscountProgressBar(cart, currency);
      if ($('.cd__timer').length) startCountdown(); // Restart Reserved Timer
      setTimeout(() => $('.cd-upsells__out').addClass('active'), 300);
    });
  }, delay);
}

buildCart();

// ========================== Cart Drawer Functionality ==========================
function updateCartQuantity(action, element) {
  const $cartItem = $(element).closest('.cd__item');
  $cartItem.addClass('loading');

  const { id, key } = $cartItem.data();
  const properties = JSON.parse(decodeURIComponent($cartItem.find('.cd__item-properties').attr('data-properties') || '{}'));
  let quantity = parseFloat($cartItem.find('.cd__item-quantity-value').html());
  if (action === 'plus') quantity++;
  if (action === 'minus') quantity--;
  if (action === 'remove') quantity = 0;

  const data = { updates: { [key]: quantity } };
  log(data, 'data');

  // Check if this is a bundle item being removed
  if ((action === 'remove' || action === 'minus') && quantity <= 0) {
    const bundleId = properties._bundle_id;
    if (bundleId) {
      // Remove all items with the same bundle ID
      const itemsToRemove = [];
      $('.cd__item').each((_, item) => {
        const $item = $(item);
        const itemBundleId = $item.find('.cd__item-properties').text().match(/_bundle_id: ([^\s]+)/)?.[1];
        if (itemBundleId === bundleId) {
          itemsToRemove.push({ id: $item.attr('data-id'), quantity: 0 });
        }
      });

      if (itemsToRemove.length > 1) {
        $.post("/cart/update.js", { updates: itemsToRemove.reduce((acc, item) => ({ ...acc, [item.id]: 0 }), {}) }, function () {
          buildCart();
          setTimeout(function () {
            $('.cd__item').removeClass('loading');
          }, 1500);
        }, "json");
        return;
      }
    }
  }

  $.post("/cart/update.js", data)
    .done(buildCart)
    .fail(() => log.collapse('Failed to update cart quantity', 'error'))
    .always(() => setTimeout(() => $('.cd__item').removeClass('loading'), 1500));
}

$(document).on("click", ".cd__item-quantity-plus", function () {
  updateCartQuantity('plus', this);
});
$(document).on("click", ".cd__item-quantity-minus", function () {
  updateCartQuantity('minus', this);
});
$(document).on("click", ".cd__item-remove", function () {
  updateCartQuantity('remove', this);
});

// ========================== Variant Change (Selector) ==========================
const handleVariantChange = function ($el, id) {
  if (!$el.length || !id) return;
  const $cartItem = $el.closest('.cd__item');
  const quantity = parseFloat($cartItem.find('.cd__item-quantity-value').html());
  const { key } = $cartItem.data();
  $cartItem.addClass('loading');
  $.post('/cart/update.js', { updates: { [key]: 0 } }, () =>
    $.post('/cart/add.js', { id, quantity }, () => {
      buildCart();
      setTimeout(() => $('.cd__item').removeClass('loading'), 1500);
    }, 'json')
    , 'json');
};

$(document).on("click", ".cd__item-selector.main-select .main-select__item", function () {
  handleVariantChange($(this), $(this).data('value'));
});

// ========================== Cart Drawer Functionality END ==========================


// ========================== Cart Drawer Interactions ==========================
$('.header__icon-list a[href="/cart"][aria-controls="cart-drawer"]').click(function (evt) {
  evt.preventDefault();
  openSlideCart();
});

$('.header_listicle-cart-only [aria-controls="cart-drawer"]').click(function (evt) {
  evt.preventDefault();
  openSlideCart();
});

$('.cd__nav-back').click(closeSlideCart);
$('.cd__outer').click(function (e) {
  if (!$(e.target).closest('.cd__inner').length) {
    closeSlideCart();
  }
});

$('.cd__checkout-btn').click(function (e) {
  const dataId = $('.cd__ship-prot').data('id');
  const shipProtEnabled = dataId && !$('.cd__ship-prot-checking').hasClass('disabled');

  if (window.__shipProtCartPending) {
    e.preventDefault();
    window.__shipProtCartPending.then(() => { window.location.href = '/checkout'; });
    return;
  }

  if (!shipProtEnabled) {
    window.location.href = '/checkout';
    return;
  }

  e.preventDefault();
  $.getJSON('/cart.js', ({ items }) => {
    const inCart = items.some(item => item.id == dataId && item.quantity > 0);
    if (inCart) {
      window.location.href = '/checkout';
      return;
    }
    syncShipProtToCart(1).then(() => { window.location.href = '/checkout'; });
  });
});

$(document).on('mouseover', '.cd__item-remove', e => $(e.target).addClass('active'))
  .on('mouseleave', '.cd__item-remove', e => $(e.target).removeClass('active'));

// ========================== Cart Drawer Interactions END ==========================


// ========================== Shipping Protection ==========================
const syncShipProtToCart = (targetQty) => {
  const dataId = $('.cd__ship-prot').data('id');
  if (!dataId) return Promise.resolve();

  const request = new Promise((resolve, reject) => {
    $.post('/cart/update.js', { updates: { [dataId]: targetQty } })
      .done(() => {
        log(`${targetQty ? 'Added' : 'Removed'} Shipping-Protection`);
        resolve();
      })
      .fail(() => {
        log.collapse(`${targetQty ? 'Failed to add' : 'Failed to remove'} Shipping-Protection`, 'error');
        reject();
      });
  });

  window.__shipProtCartPending = request.finally(() => {
    window.__shipProtCartPending = null;
  });

  return window.__shipProtCartPending;
};

const refreshShipProtCheckoutPrice = () => {
  const currency = $('.cd__checkout-btn').attr('data-cur')?.replace('0,00', '').replace('0.00', '') || '';
  $.getJSON('/cart.js', cart => {
    const cart_total = (cart.total_price / 100).toFixed(2);
    $('.cd__footer-prices-line[data-value="total"] span.value').html(`${currency}${cart_total}`);
    $('.cd__checkout-price').html(currency + cart_total);
  });
};

const setShippingProtectionDisabled = () => {
  localStorage.setItem('shippingProtectionDisabled', JSON.stringify({
    value: 'true',
    expiry: Date.now() + (60 * 60 * 1000)
  }));
};

$(document).on("click", ".cd__ship-prot-checking", function () {
  const $checking = $(this);
  const wasDisabled = $checking.hasClass('disabled');
  $checking.toggleClass('disabled');

  if (!wasDisabled) setShippingProtectionDisabled();
  else localStorage.removeItem('shippingProtectionDisabled');

  const targetQty = $checking.hasClass('disabled') ? 0 : 1;
  $checking.addClass('loading');

  syncShipProtToCart(targetQty)
    .then(() => {
      refreshShipProtCheckoutPrice();
      buildCart({ skipDelay: true });
    })
    .finally(() => $checking.removeClass('loading'));
});

function initProtection(dataId) {
  if (!dataId || !window.__shipProtLocationReady || window.__shipProtCartPending) return;

  $.getJSON("/cart.js", ({ items, item_count }) => {
    if (item_count > 0) {
      const dataQty = items.find(item => item.id == dataId)?.quantity || 0;
      const targetQty = $('.cd__ship-prot-checking').hasClass('disabled') ? 0 : 1;

      if (dataQty !== targetQty) {
        syncShipProtToCart(targetQty)
          .then(() => buildCart({ skipDelay: true }));
      }
    }
  });
}

const SHIP_PROT_EU = new Set('AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'.split(','));
const SHIP_PROT_REGION_CACHE_KEY = 'theme:ship-prot-region';

const shipProtExcludeHasUsRegion = (excludeRaw) =>
  excludeRaw.split(',').some((raw) => /^US-[A-Z0-9]{1,3}$/i.test(raw.trim()));

const isShipProtLocationExcluded = (excludeRaw, countryIso, provinceIso = '') => {
  const country = countryIso.toUpperCase();
  const province = provinceIso.toUpperCase();

  return excludeRaw.split(',').some((raw) => {
    const token = raw.trim().toUpperCase().replace(/^UK$/, 'GB');
    if (!token) return false;
    if (token === 'EU') return SHIP_PROT_EU.has(country);
    if (token.includes('-')) {
      const [excludeCountry, excludeRegion] = token.split('-');
      return country === excludeCountry && province === excludeRegion;
    }
    return token === country;
  });
};

const toggleSwitchDefault = () => {
  $('.cd__ship-prot-checking').toggleClass('disabled', $('.cd__ship-prot').attr('data-protection') !== 'true');
};

const fetchShipProtDetectedCountry = async () => {
  try {
    const root = window.Shopify?.routes?.root || '/';
    const data = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`).then((response) => response.json());
    return (data?.detected_values?.country?.handle || '').toUpperCase();
  } catch (error) {
    log.collapse(error, 'Ship prot geo lookup failed', 'warning');
    return '';
  }
};

const fetchShipProtUsRegionCode = async () => {
  const country = 'US';

  try {
    const cached = sessionStorage.getItem(SHIP_PROT_REGION_CACHE_KEY);
    if (cached) {
      const { region, expiry } = JSON.parse(cached);
      if (Date.now() < expiry) return region;
    }
  } catch {
    /* ignore cache parse errors */
  }

  try {
    const data = await fetch('https://ipwho.is/', { priority: 'low' }).then((response) => response.json());
    if (!data?.success || (data.country_code || '').toUpperCase() !== country) return '';
    const region = (data.region_code || '').toUpperCase();
    if (region) {
      sessionStorage.setItem(SHIP_PROT_REGION_CACHE_KEY, JSON.stringify({
        region,
        expiry: Date.now() + 6 * 60 * 60 * 1000
      }));
    }
    return region;
  } catch (error) {
    log.collapse(error, 'Ship prot region lookup failed', 'warning');
    return '';
  }
};

const applyShipProtLocationDefault = async () => {
  const $shipProt = $('.cd__ship-prot');
  if (!$shipProt.length) return;

  let optIn = $shipProt.attr('data-ship-prot-default') === 'true';
  const excludeRaw = $shipProt.attr('data-ship-prot-exclude');

  if (optIn && excludeRaw) {
    const countryIso = await fetchShipProtDetectedCountry();
    let provinceIso = ($shipProt.attr('data-province') || '').toUpperCase();

    if (countryIso === 'US' && !provinceIso && shipProtExcludeHasUsRegion(excludeRaw)) {
      provinceIso = await fetchShipProtUsRegionCode();
      if (provinceIso) $shipProt.attr('data-province', provinceIso);
    }

    if (countryIso && isShipProtLocationExcluded(excludeRaw, countryIso, provinceIso)) optIn = false;
  }

  if (optIn) $shipProt.attr('data-protection', 'true');
  else $shipProt.removeAttr('data-protection');

  toggleSwitchDefault();
};

const deferShipProtTask = (task) => {
  if ('requestIdleCallback' in window) requestIdleCallback(task, { timeout: 2500 });
  else setTimeout(task, 1);
};

const applyShipProtLocalStorageOverride = () => {
  const storedData = localStorage.getItem('shippingProtectionDisabled');
  if (!storedData) return;

  const { value, expiry } = JSON.parse(storedData);
  if (value === 'true' && Date.now() < expiry) {
    $('.cd__ship-prot-checking').addClass('disabled');
  } else {
    localStorage.removeItem('shippingProtectionDisabled');
  }
};

const startShipProtSync = (dataId) => {
  window.__shipProtLocationReady = true;
  initProtection(dataId);
  if (!window.__shipProtSyncInterval) window.__shipProtSyncInterval = setInterval(() => initProtection(dataId), 500);
};

$(document).ready(function () {
  const $shipProt = $('.cd__ship-prot');
  const dataId = $shipProt.data('id');
  const excludeRaw = $shipProt.attr('data-ship-prot-exclude');

  // Disable checkbox when shipping protection is removed from cart in cart page
  $(`a[href^="/cart/change?id=${dataId}"]`).click(() => {
    $('.cd__ship-prot-checking').addClass('disabled');
    setShippingProtectionDisabled();
    log.collapse('Removing shipping protection from cart page and unchecking in cart drawer', 'Cart ShipProt Removed', 'warning');
  });

  if (!excludeRaw) {
    toggleSwitchDefault();
    applyShipProtLocalStorageOverride();
    startShipProtSync(dataId);
    return;
  }

  deferShipProtTask(async () => {
    await applyShipProtLocationDefault();
    applyShipProtLocalStorageOverride();
    startShipProtSync(dataId);
  });
});

// ========================== Shipping Protection END ==========================

// ========================== Discount Bar ==========================
$(document).on("click", ".discount-bar__gift-header-close", function () {
  $('discount-progress-bar-gift').hide();
});


function updateDiscountProgressBar(cart, currency) {
  const $progressBar = $(".discount-bar__progress-bar");
  const $progressFill = $(".discount-bar__progress-fill");
  const $freeShippingStatus = $(".discount-bar__status p");
  const $giftStatus = $(".discount-bar__gift-header p");
  const currency_symbol = $('<div>').html(currency).text();
  let giftId = null;

  // Calculate total price
  let totalPrice = cart.items.reduce((sum, item) =>
    (item.requires_shipping || item.handle.includes("shipping-protection")) ? sum + item.final_line_price : sum, 0);
  totalPrice -= cart.cart_level_discount_applications.reduce((sum, discount) =>
    sum + discount.total_allocated_amount, 0);

  // Initialize thresholds
  const thresholds = $(".discount-bar__threshold").map(function () {
    const id = $(this).data("id");
    if (id) giftId = id;
    return {
      value: parseFloat($(this).data("value")),
      isGift: $(this).data("type") === "gift",
      id: id,
      element: $(this)
    };
  }).get();

  // Progress bar logic
  let fillPercentage = 0;
  let freeShippingUnlocked = false;
  let giftUnlocked = false;
  let nextThreshold = null;
  const progressStep = 100 / thresholds.length;

  thresholds.forEach(threshold => threshold.element.removeClass("discount-bar__threshold--filled"));

  thresholds.forEach((threshold, index) => {
    const prevValue = thresholds[index - 1]?.value || 0;
    if (totalPrice >= threshold.value) {
      fillPercentage = (index + 1) * progressStep;
      threshold.element.addClass("discount-bar__threshold--filled");
      if (threshold.isGift) { giftUnlocked = true; giftId = threshold.id; }
      else freeShippingUnlocked = true;
    } else if (totalPrice > prevValue) {
      const range = threshold.value - prevValue;
      fillPercentage = (index * progressStep) + ((totalPrice - prevValue) / range) * progressStep;
      if (!nextThreshold) nextThreshold = threshold;
    } else if (!nextThreshold) nextThreshold = threshold;
  });

  $progressFill.css("width", `${fillPercentage}%`);

  // Update statuses
  const formatRemaining = (threshold) => currency_symbol + ((threshold.value - totalPrice) * 0.01).toFixed(2);

  $freeShippingStatus.html(freeShippingUnlocked
    ? `You've unlocked <span class="discount-bar__status-value">Free Shipping</span>!`
    : `You're ${formatRemaining(thresholds.find(t => !t.isGift))} away from <span class="discount-bar__status-value">Free Shipping</span>!`
  );

  const giftThreshold = thresholds.find(t => t.isGift);
  if (giftThreshold) {
    const giftStatusMessage = giftUnlocked ? 'Free Gift Included!' : `Add ${formatRemaining(giftThreshold)} more to unlock Free Gift`;
    $giftStatus.html(giftStatusMessage);

    const giftItem = cart.items.find(item => item.product_id === giftId);
    log.collapse(thresholds, 'thresholds');
    log.collapse({ giftThreshold, giftUnlocked, giftId, giftItem, giftStatusMessage }, 'Gift Threshold Status', 'info');

    if (giftUnlocked && !giftItem) {
      log.collapse({ giftId }, 'Gift Unlocked, opening modal', 'warning');
      $('.cd__gift-selector-modal').addClass('active').show();
    } else if (!giftUnlocked && giftItem) {
      log.collapse({ giftId, quantity: 0 }, 'Removing gift from cart', 'warning');
      postToCart([{ id: giftId, quantity: 0 }], buildCart);
    }
  }
}

$(document).on('click', '.cd__gift-selector-modal .modal-close', function () {
  $('.cd__gift-selector-modal').removeClass('active').hide();
});

$(document).on('click', '.cd__gift-selector-modal-atc', function () {
  const selectedColor = $('.cd__gift-selector-modal-selector[data-type="color"] .main-select__item[data-selected="true"]').data('value');
  const selectedSize = $('.cd__gift-selector-modal-selector[data-type="size"] .main-select__item[data-selected="true"]').data('value');
  const selectedId = $('.cd__gift-variant[data-color="' + selectedColor + '"][data-size="' + selectedSize + '"]').data('id') || $(this).data('id');
  log.collapse({ selectedId, selectedColor, selectedSize }, 'Selected Free Gift Variant', 'info');
  const loadingCallback = () => $('.cd__gift-selector-modal-atc').addClass('loading');
  const successCallback = () => {
    $('.cd__gift-selector-modal').removeClass('active').hide();
    $('.cd__gift-selector-modal-atc').removeClass('loading');
    buildCart();
  };
  const failCallback = () => {
    $('.cd__gift-selector-modal-atc').removeClass('loading');
    alert('Error adding gift to cart');
  };
  postToCart([{ id: selectedId, quantity: 1 }], successCallback, loadingCallback, failCallback);
});

// ========================== Discount Bar END ==========================

// ========================== Upsells ==========================
$('.cd-upsells__carousel').slick({
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Left.png?v=1737122129'/></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Right.png?v=1737122129'/></button>",
});

$('.cd-upsells__toggle').click(function () { $('.cd-upsells__out').toggleClass('active') })

$(document).on('click', '.cd-upsells__block-selector.main-select .main-select__item', function () {
  const currentId = $(this).data('value');
  const parentBlock = $(this).closest('.cd-upsells__block-wrapper');
  log(parentBlock, 'parentBlock');
  parentBlock.find('.cd-upsells__block-atc').attr('data-id', currentId);

  const currency = $('.cd__checkout-btn').attr('data-cur').replace('0,00', '').replace('0.00', '');
  const currentPrice = $(this).data('price');
  parentBlock.find('.cd-upsells__block-price .pri').html(`${currency}${(currentPrice / 100).toFixed(2)}`);

  const currentComparePrice = $(this).data('compare-price');
  let currentDiscount = 0;
  if (currentComparePrice) {
    currentDiscount = Math.round((currentComparePrice - currentPrice) * 100 / currentComparePrice);
    parentBlock.find('.cd-upsells__block-price s').html(`${currency}${(currentComparePrice / 100).toFixed(2)}`);
    parentBlock.find('.cd-upsells__block-price .badge').html(`${currentDiscount}% OFF`);
  }
  log.collapse({ currentId, currentPrice, currentComparePrice, currentDiscount }, 'Current Variant', 'info');
});

$(".cd-upsells__block-atc").on("click", function (evt) {
  evt.preventDefault();
  const currentId = $(this).attr("data-id");
  log(currentId, 'currentId');
  postToCart([{ id: currentId, quantity: 1 }], buildCart);
});

// ========================== Upsells END ==========================


// ========================== Cart Reserved Timer ==========================
let updateTimer;
function startCountdown() {
  // Clear any existing timer
  if (updateTimer) clearInterval(updateTimer);

  const cart_reserved_timer = $('.cd__timer').data('timer'); // in minutes
  const countDownDate = new Date(Date.now() + cart_reserved_timer * 60 * 1000);

  updateTimer = setInterval(() => {
    const distance = countDownDate - new Date();

    if (distance <= 0) {
      clearInterval(updateTimer);
      $(".cd_timer-reserved__hour, .cd_timer-reserved__min, .cd_timer-reserved__sec").text('0');
      $('.cd__timer-reserved p').text('Time is out!');
      $.post('/cart/clear.js', function () {
        buildCart();
      });
    } else {
      const [hours, minutes, seconds] = [
        Math.floor((distance / (1000 * 60 * 60)) % 24),
        Math.floor((distance / (1000 * 60)) % 60),
        Math.floor((distance / 1000) % 60),
      ];
      $(".cd_timer-reserved__hour").text(hours);
      $(".cd_timer-reserved__min").text(minutes);
      $(".cd_timer-reserved__sec").text(seconds);
    }
  }, 1000);
}

if ($('.cd__timer').length) startCountdown();

// ========================== Cart Reserved Timer END ==========================


// ========================== ATC to Cart Drawer ==========================
$(document).on("click", "buy-buttons button[type='submit']", function () {
  openSlideCart();
});

$(document).on("submit", ".shopify-product-form", function () {
  openSlideCart();
  var prevCount = parseInt($(".cd__units span").text()) || 0;
  var attempts = 0;

  function poll() {
    if (attempts++ >= 12) return; // give up after ~6s
    $.getJSON("/cart.js", function (cart) {
      if (cart.item_count > prevCount) {
        buildCart();
      } else {
        setTimeout(poll, 500);
      }
    });
  }

  setTimeout(poll, 300);
});

// ========================== Gempages ATC ==========================
// Scoped add-to-cart handler: operates per .productBox instance
$(document).on('click', '.gempages_pp-atc-btn', function () {
  var $btn = $(this);
  var $box = $btn.closest('.productBox');
  if (!$box.length) $box = $('.productBox').first(); // fallback

  $btn.addClass('btnAdding');

  var currentId = $btn.attr('data-id');
  var currentQty = 1;

  // find bundle bar inside this product box
  var $bar = $box.find('.kaching-bundles__bar:has(input:checked)');
  if (!$bar.length) $bar = $box.find('.kaching-bundles__bar--selected');

  var itemCount = $bar.find('.kaching-bundles__bar-variant').length;

  if (itemCount <= 1) {
    // ONE variant bundle (scoped)
    console.log('ONE variant bundle (scoped)');
    var items = [];
    items.push({
      id: currentId,
      quantity: 1
    });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: items },
      dataType: "json",
      success: function () {
        // keep global behavior (openSlideCart / buildCart are assumed global)
        openSlideCart();
        buildCart();
        $box.find('.header_listicle-cart-only').removeClass('hidedHeader');
        $btn.removeClass('btnAdding');
      },
      error: function () {
        alert("Error adding item to the cart.");
        $btn.removeClass('btnAdding');
      }
    });

  } else {
    // MULTI variant bundle (scoped)
    console.log('MULTI variant bundle (scoped):', itemCount);
    var items = [];

    $bar.find('.kaching-bundles__bar-variant__content').each(function () {
      var itemTitle = '';

      $(this).find('.kaching-bundles__bar-variant-select').each(function (index) {
        var currentTitle = $(this).val();
        if (index === 0) {
          itemTitle = currentTitle;
        } else {
          itemTitle += ' / ' + currentTitle;
        }
      });

      // find variant id within this productBox
      var currentIdLookup = $box.find('.gempages_pp-variant-selection[data-full-title="' + itemTitle + '"]').attr('data-id');
      items.push({
        id: currentIdLookup,
        quantity: 1
      });
    });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: items },
      dataType: "json",
      success: function () {
        openSlideCart();
        buildCart();
        $box.find('.header_listicle-cart-only').removeClass('hidedHeader');
        $btn.removeClass('btnAdding'); // remove only from the clicked button
      },
      error: function () {
        alert("Error adding item to the cart.");
        $btn.removeClass('btnAdding');
      }
    });
  }
});

// ========================== ATC to Cart Drawer END ==========================


// ========================== Cart Drawer GLOBAL ==========================

function openSlideCart() {
  $('.cd__outer').css('display', 'flex');
  setTimeout(function () {
    $("body").addClass("Overflow_hidden");
    $("body").addClass("overflow-hidden");
    $('.cd__outer').addClass('active');
    $('.cd-upsells__carousel').slick('refresh');
  }, 100);
}

function closeSlideCart() {
  $('.cd__outer').removeClass('active');
  setTimeout(function () {
    $('.cd__outer').hide();
    $("body").removeClass("Overflow_hidden");
    $("body").removeClass("overflow-hidden");
  }, 300);
}
window.cart_open = openSlideCart;
window.cart_close = closeSlideCart;
window.cart_build = buildCart;



